export const regexAcronymState = /(^\w{2}\*$)|(^\w{3}$)|(^\w{1}$)|(^\w{2}$)/gi;

export const regexFiscalCode = /^\w{1}\d{3}$/gi;
